import { Button } from '@chakra-ui/react';
import { Box, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { GoKebabHorizontal } from "react-icons/go";
import { displayReactIcon } from "../helpers/dsr-display-helpers";
import LaunchdeckTag from "../../global/components/helper-components/components/LaunchdeckTag";


export default function DsrReplyOptionsButton({ 
  isAuthor,
  handleChangeUserActionRequired,
  isDsrAdmin,
  dsrId,
  postId,
  replyId,
  onClickDeleteReplyOption,
  confirmationType,
  replyObject
 }) {


     const renderOptions = () => {
        const handleReportReply = () => {
          handleChangeUserActionRequired('report-updates-reply', {
            dsrId,
            postId,
            replyId,
          })
        }

        const handleEditReply = () => {
          handleChangeUserActionRequired("edit-dsr-reply", {
            postIdToEdit: postId, 
            replyIdToEdit: replyId,
            // postTagProperties: ,
            replyObject: replyObject,
            userActionRequired:'edit-dsr-reply'
           })
        }
        
        if (isAuthor) {
          return (
            <>
             <MenuItem name='showEditReplyModal' className='filter-menu__dropdown-option-display' onClick={()=>handleEditReply()}> {displayReactIcon("edit","1em")} Edit reply</MenuItem> 
             <MenuItem name='showDeleteReplyModal' className='filter-menu__dropdown-option-display' onClick={()=>onClickDeleteReplyOption({postId, replyId}, confirmationType)}> {displayReactIcon("remove-post","1em")} Delete reply</MenuItem>
            </>
          )
        } else {
          return (
            <>
              {isDsrAdmin ?
                <MenuItem name='showDeleteReplyModal' className='filter-menu__dropdown-option-display' onClick={() => onClickDeleteReplyOption({postId, replyId}, confirmationType)}> 
                <span><LaunchdeckTag bg='brandGreen.500' py='0em' color='white' reactIcon={"mod-action"} label='MOD'/></span>Delete reply </MenuItem>
                :
                <MenuItem name='showReportReplyModal' className='filter-menu__dropdown-option-display' onClick={() => handleReportReply()}> {displayReactIcon("report", "1em")} Report this</MenuItem>
              }
            </>
          )
        }
      }

    return (
      <>
        <Menu closeOnSelect={true} >
          <MenuButton as={Button} rounded='0.25em' px='1em' ml='2em'>
            <Box as={GoKebabHorizontal} boxSize="1.5em" />
          </MenuButton>
          <MenuList zIndex={2}  minWidth="10em" fontSize='0.875em'>
            {renderOptions()}
          </MenuList>
        </Menu>
      </>
    );
  
}


